import {AssetMaterialsBreakdownApiDto} from "../../api/model/rest";
import Amount from "../common/Amount";
import MaterialPerMerchant from "./MaterialPerMerchant";

/**
 * Asset materials breakdown model
 */
export default class AssetMaterialsBreakdown {
	constructor(public readonly merchantId: string,
		public readonly merchantName: string,
		public readonly materials: MaterialPerMerchant[]) {}

	static fromJson(json: AssetMaterialsBreakdownApiDto): AssetMaterialsBreakdown {
		return new AssetMaterialsBreakdown(json.merchantId, json.merchantName, json.materials.map(MaterialPerMerchant.fromJson));
	}

	/**
	 * Calculate total buy price per merchant
	 * @returns total materials buy price per merchant
	 */
	calculateTotalBuyPricePerMerchant(): Amount {
		const sumPrice = this.materials.map(m => m.price.isDefined ? m.quantity * m.price.get.cents : 0)
			.reduce((a, b) => a + b, 0);
		return new Amount(sumPrice);
	}

}